import { type ShippingAddressFormValues } from '../address/types';
import { LoginType } from '../login/types';

export enum SignupType {
  Apple = 'Apple',
  Google = 'Google',
  MagicLink = 'MagicLink',
  Ebay = 'Ebay',
}

export type SocialSignupType =
  SignupType.Apple | SignupType.Google | SignupType.Ebay;

export enum SignupSubmitTrackingLoginType {
  Apple = LoginType.Apple,
  Google = LoginType.Google,
  MagicLink = LoginType.MagicLink,
  Ebay = LoginType.Ebay,
}

export type DobFieldName = 'dobDay' | 'dobMonth' | 'dobYear';

export type UserSignupDetails = {
  firstName: string;
  lastName?: string;
  username: string;
  email: string;
  marketingConsent: boolean;
  country: string;
  googleIdToken?: string;
  apple_user_id?: string;
  apple_access_token?: string;
  ebay_user_id?: string;
  ebay_token_reference?: string;
  dobDay?: string;
  dobMonth?: string;
  dobYear?: string;
};

export type SignupDetailsWithShippingAddress = UserSignupDetails &
  ShippingAddressFormValues & { lastName: string };

export type SignupRequest = {
  userDetails: UserSignupDetails;
  verificationId?: string;
  magicLinkToken?: string;
};

export type SignupResponse = {
  token: string;
  publicId: string;
};

export type SignupErrorResponse = {
  error: string;
  description: string;
};

export enum SignupErrorTypes {
  UnknownError = 'unknown',
  Username = 'username',
  Dob = 'dob',
  OtherError = 'other',
}

export type SignupErrorDetails = {
  errorType: SignupErrorTypes;
  errorMessage: string;
};

export type StoredMagicLinkInfo = {
  email: string | null;
  verificationId: string | null;
  magicLinkToken: string | null;
};
